import React, { Component } from "react";
import { connect } from "react-redux";
import { userActions } from "../../_actions";
import { userConstants } from "../../_constants";

class Portal_ extends Component {
  constructor(props) {
    super(props);
    this.state = { timeZone: "" };
    this.globalStorage = this.props.globalStorage;
    this.hospital_id = props.match.params.id;
  }

  componentDidMount = () => {
    this.getHospitals();
    this.getPrayerTimes();
    this.getApplicationLinks();
    this.getAnnouncements();
    // this.getPhones();
    // this.getLinks();
    this.getUserBirths();
  };

  getTimeZone = () => {
    this.props
      .dispatch(userActions.API("get", `v1/time`, null, true))
      .then((res) => {
        this.setState({
          timeZone: res.data.split("+")[1],
        });
      })
      .catch(() => userActions.failure(userConstants.ERRORS["serverError"]));
  };

  getUserBirths = () => {
    this.props
      .dispatch(
        userActions.API(
          "get",
          `v1/user/hospital/user_births?hospital_id=10`,
          null,
          true
        )
      )
      .then((res) => {
        //   this.setState({})
      })
      .catch(() => userActions.failure(userConstants.ERRORS["serverError"]));
  };

  // getLinks = () => {
  //   this.props
  //     .dispatch(
  //       userActions.API(
  //         "get",
  //         `v1/user/hospital/links`,
  //         null,
  //         true
  //       )
  //     )
  //     .then((res) => {
  //       //   this.setState({})
  //     })
  //     .catch(() => userActions.failure(userConstants.ERRORS["serverError"]));
  // };

  // getPhones = () => {
  //   this.props
  //     .dispatch(
  //       userActions.API(
  //         "get",
  //         `v1/user/hospital/phones`,
  //         null,
  //         true
  //       )
  //     )
  //     .then((res) => {
  //       //   this.setState({})
  //     })
  //     .catch(() => userActions.failure(userConstants.ERRORS["serverError"]));
  // };

  getDetail = (id) => {
    this.props
      .dispatch(
        userActions.API("get", `v1/hospital/${10}/detail`, null, true, false)
      )
      .then((res) => {
        //   this.setState({})
      })
      .catch(() => userActions.failure(userConstants.ERRORS["serverError"]));
  };

  getHospitals = () => {
    this.props
      .dispatch(userActions.API("get", `v1/hospitals`, null, true))
      .then((res) => {
        // this.getDetail(res.data.hospital_id);
        this.getDetail();
        //   this.setState({})
      })
      .catch(() => userActions.failure(userConstants.ERRORS["serverError"]));
  };

  getPrayerTimes = () => {
    this.props
      .dispatch(
        userActions.API(
          "get",
          "https://prayer.aviny.com/api/prayertimes/1",
          null,
          true
        )
      )
      .then((res) => {
        //   this.setState({})
      })
      .catch(() => userActions.failure(userConstants.ERRORS["serverError"]));
  };

  getApplicationLinks = () => {
    // { application_link_id: 10 },
    this.props
      .dispatch(
        userActions.API(
          "get",
          `v1/user/hospital/application_links?hospital_id=10`,
          null,
          true
        )
      )
      .then((res) => {
        //   this.setState({})
      })
      .catch(() => userActions.failure(userConstants.ERRORS["serverError"]));
  };

  getAnnouncements = () => {
    this.props
      .dispatch(
        userActions.API(
          "get",
          `v1/user/hospital/announcements?hospital_id=10`,
          null,
          true
        )
      )
      .then((res) => {
        //   this.setState({})
      })
      .catch(() => userActions.failure(userConstants.ERRORS["serverError"]));
  };

  reset = () => {
    this.setState({});
  };

  render() {
    return (
      <div className="container-fluid px-5 pb-5 mt-3 portal">
        <div className="row">
          <div className="col-lg-9 col-md-12 m-auto"></div>
        </div>
      </div>
    );
  }
}

const Portal = connect((state) => ({
  globalStorage: state.globalStorage,
}))(Portal_);

export { Portal };
